import { useEffect, useRef } from 'react';

import { useAnalytics } from '@townsquare/analytics';
import { setFavicon } from '@townsquare/dynamic-favicon';
import {
	useRovoAppification,
	useIsEligibleForRovoAppification,
} from '@townsquare/rovo/appification';
import { useRovoEntitlement } from '@townsquare/rovo/entitlement';
import { manuallyFireExperimentExposure } from '@townsquare/stat-sig';
import { TOWNSQUARE_ENABLE_ROVO_HOME_APPIFICATION_EXP } from '@townsquare/stat-sig/experiments';
import { fg } from '@townsquare/stat-sig/gate';

export const RovoAppificationHandler = () => {
	const { rovoAppificationState } = useRovoAppification();
	const { isEligibleForAppification } = useIsEligibleForRovoAppification();
	const rovoEntitlement = useRovoEntitlement();
	const analytics = useAnalytics();
	const hasFiredRef = useRef(false);

	useEffect(() => {
		if (hasFiredRef.current) {
			return;
		}

		if (rovoAppificationState !== 'loading' && !rovoEntitlement.loading && rovoEntitlement.data) {
			const homeAppType = rovoAppificationState === 'enabled' ? 'rovo' : 'classic';

			void analytics.setTopLevelAttributes({
				homeAppType,
			});

			void analytics.operational('homeApp', 'loaded', {
				isRovoEnabled: rovoEntitlement.data.isRovoEnabled,
				isRovoLLMEnabled: rovoEntitlement.data.isRovoLLMEnabled,
				rovoAppification: rovoAppificationState === 'enabled',
			});

			hasFiredRef.current = true;

			// explicitly fire experiment exposure for eligible users in experiment cohorts
			if (
				fg('townsquare_enable_rovo_appification_v2') &&
				isEligibleForAppification === 'eligible'
			) {
				manuallyFireExperimentExposure(TOWNSQUARE_ENABLE_ROVO_HOME_APPIFICATION_EXP);
			}

			if (rovoAppificationState === 'enabled') {
				setFavicon('rovo');
			} else {
				setFavicon('home');
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		rovoAppificationState,
		rovoEntitlement.loading,
		rovoEntitlement.data?.isRovoEnabled,
		rovoEntitlement.data?.isRovoLLMEnabled,
	]);

	return null;
};
